import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { ScreenReaderSpan } from './ScreenReader.styles.js';

var ScreenReader = function ScreenReader(_a) {
  var string = _a.string,
      props = __rest(_a, ["string"]);

  return React.createElement(ScreenReaderSpan, __assign({}, props), string);
};

export { ScreenReader };